import { render, staticRenderFns } from "./StoreOrder.vue?vue&type=template&id=b4a0482e&scoped=true"
import script from "./StoreOrder.vue?vue&type=script&lang=js"
export * from "./StoreOrder.vue?vue&type=script&lang=js"
import style0 from "./StoreOrder.vue?vue&type=style&index=0&id=b4a0482e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a0482e",
  null
  
)

export default component.exports